import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  lastUpdated,
  children
}: LegalModalProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-71">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-72">
          <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[85vh] flex flex-col bg-slate-900 border border-white/10 rounded-2xl shadow-2xl overflow-hidden" data-id="element-73">
            {/* Header */}
            <div className="flex items-start justify-between gap-4 px-6 md:px-8 py-6 border-b border-white/10 shrink-0" data-id="element-74">
              <div data-id="element-75">
                <h2 id="legal-modal-title" className="text-2xl font-bold text-white" data-id="element-76">
                  {title}
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-77">
                  Última actualización: {lastUpdated}
                </p>
              </div>
              <button ref={closeButtonRef} onClick={onClose} aria-label="Cerrar" className="shrink-0 p-2 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500/50" data-id="element-78">
                <X className="w-5 h-5" data-id="element-79" />
              </button>
            </div>

            {/* Scrollable body */}
            <div className="px-6 md:px-8 py-6 overflow-y-auto text-slate-300 leading-relaxed space-y-5" data-id="element-80">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}